import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import GiftInfo from '../entities/gift-package'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface GiftInfoState extends ListState<GiftInfo> {
    editGiftInfo: GiftInfo;
    permissions: Array<string>
}

class GiftInfoModule extends ListModule<GiftInfoState, any, GiftInfo> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<GiftInfo>(),
        loading: false,
        editGiftInfo: new GiftInfo(),
        permissions: new Array<string>()
    }
    actions = {
        async getAll(context: ActionContext<GiftInfoState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/GiftInfo/GetAll', {params: payload.data});
            context.state.loading = false;
            let page = response.data.result as PageResult<GiftInfo>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<GiftInfoState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/GiftInfo/Create', payload.data);
            context.state.loading = false;
        },
        async update(context: ActionContext<GiftInfoState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/services/app/GiftInfo/Update', payload.data);
            context.state.loading = false;
        },
        async delete(context: ActionContext<GiftInfoState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.delete('/api/services/app/GiftInfo/Delete?Id=' + payload.data.id);
            context.state.loading = false;
        },
        async get(context: ActionContext<GiftInfoState, any>, payload: any) {
            let response = await Ajax.get('/api/services/app/GiftInfo/Get?Id=' + payload.id);
            return response.data.result as GiftInfo;
        },
        async getAllPermissions(context: ActionContext<GiftInfoState, any>) {
            let response = await Ajax.get('/api/services/app/GiftInfo/getAllPermissions');
            context.state.permissions = response.data.result.items;
        }
    };
    mutations = {
        setCurrentPage(state: GiftInfoState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: GiftInfoState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: GiftInfoState, giftInfo: GiftInfo) {
            state.editGiftInfo = giftInfo;
        }
    }
}

const giftInfoModule = new GiftInfoModule();
export default giftInfoModule;